<a *ngIf="isShopvoteReputationLoaded$ | async" href="https://www.shopvote.de/bewertung_geschenkzeitung_de_17463.html" target="_blank">
	<img src="https://widgets.shopvote.de/view.php?shopid=17463&bn=50&lang=de" id="svimage-50" alt="Shopbewertung - geschenkzeitung.de" border="0" align="bottom" hspace="1" />
</a>
